import { ChartProductParams, DeviceTypes } from '../types/chart'
import { EventType, Product } from '@dtx-company/connect-codegen/src/gen/analytics/v2/analytics_pb'

export interface ParamsType {
  product_id?: number
  owner_id?: string
  event_type_id: number | number[]
  asset_id?: string | string[]
  all_assets?: boolean
  page_id?: string
  asset_group_id?: string | string[]
  start_date?: string
  end_date?: string
  interval?: string
  top_count?: number
  page_num?: number
}

// - API

export enum FlowcodeEventId {
  scan = 1,
  click = 2,
  tap = 3
}

export enum FlowpageEventId {
  // These values correspond to the V2 endpoints for getting Flowpage data
  pageView = 4,
  linkClick = 5,
  crmCapture = 6
}

export enum AnalyticsProductId {
  flowcode = 3,
  flowpage = 1,
  pixel = 4
}

export const ScansParamsFC: ChartProductParams = {
  eventTypeId: [1, 2, 3],
  productId: 3
}

interface BufProductParams {
  eventType: EventType[]
  product: Product
}

export const BufScansParamsFC: BufProductParams = {
  eventType: [EventType.SCAN, EventType.SHORT_URL_CLICK, EventType.TAP],
  product: Product.FLOWCODE
}

export const LinkClickParamsFP: ChartProductParams = {
  eventTypeId: 4,
  productId: 1
}

export const BufLinkClicksParamsFP: BufProductParams = {
  eventType: [EventType.LINK_CLICK],
  product: Product.FLOWPAGE
}

export const PageVisitsParamsFP: ChartProductParams = {
  eventTypeId: 5,
  productId: 1
}

export const AllMetricsFP: ChartProductParams = {
  eventTypeId: [4, 5],
  productId: 1
}

export const FlowpageAllMetrics: ParamsType = { event_type_id: [4, 5], product_id: 1 }

// - Chart
export const pieStartAngle = 135
export const pieEndAngle = pieStartAngle + 360

// ## - Copy
// - Gain Badge
export enum GainBadgeMetric {
  NEW = 'New',
  EMPTY = ' - '
}

// - Chart Table
export const CodeChartTableColumns = ['Codes', null, 'Scans all time', 'Scans Today', 'Change']
export const PageChartTableColumns = [
  'Links',
  null,
  'Clicks all time',
  'Clicks for period',
  'Change'
]
export const AllPagesChartTableColumns = [
  'Links',
  'Flowpage',
  'Clicks all time',
  'Clicks for period',
  'Change'
]

export const FlowcodeScanDeviceTypes: DeviceTypes = { devices: ['iOS', 'Android', 'Unknown'] }
export const FlowpageLinkClickDeviceTypes: DeviceTypes = {
  devices: ['iOS', 'Android', 'Unknown'],
  subDevices: {
    ['Desktop']: ['Linux', 'ChromeOS', 'MacOS', 'Windows']
  }
}

export const ProductToDeviceTypesMap: { [productId: number]: DeviceTypes } = {
  [1]: FlowpageLinkClickDeviceTypes,
  [3]: FlowcodeScanDeviceTypes
}
